import React, { useEffect, useContext } from "react";
import { CoachesContext } from "../../context/CoachesContext";
import { getValue } from "../../utils";
import BirthdateInput from "../common/BirthdateInput";
import FileInput from "../common/FileInput";
import SelectCoachCustomer from "./SelectCoachCustomer";
import SelectDiscountCoach from "./SelectDiscountCoach";
import ReactSwitch from "react-switch";

const CoachForm = ({ idCoach, handleCancel }) => {
  const { coach, getCoach, createCoach, postCoach, setPropiedadCoach } =
    useContext(CoachesContext);

  useEffect(() => {
    fetchCoach(idCoach);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idCoach]);

  const fetchCoach = (idCoach) => {
    if (isNaN(idCoach)) {
      createCoach();
    } else {
      getCoach(idCoach);
    }
  };

  const renderShowHome = () => {
    return(
      <div className={`row mb-3`}>
        <div className="w-50 d-flex justify-content-between align-items-center">
          <label className="">Mostrar en Home</label>
          <ReactSwitch
            checked={coach.show_home}
            onChange={(checked) => {
              setPropiedadCoach('show_home', checked);
            }}
          />
        </div>

        <div className="w-50 ">
          <label className="">Orden</label>
          <input
            className="form-control"
            type="number"
            min={0}
            value={coach.order}
            onChange={(event) => {
              const value = event.target.value;
              setPropiedadCoach('order', value);
            }}
          />
        </div>
       
      </div>
    )
  }

  const handleCoachDiscount = (discount) => {
    setPropiedadCoach("discount_id", discount.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    postCoach(coach, handleCancel);
  };

  const renderForm = () => {
    if (coach && coach !== null) {
      return (
        <form onSubmit={handleSubmit}>
          <div className="row mb-3">
            <div className="col-6">
              <label>Nombre</label>
              <input
                type="text"
                className="form-control"
                value={getValue(coach, "name")}
                onChange={(e) => setPropiedadCoach("name", e.target.value)}
              />
            </div>
            <div className="col-6">
              <label>Apellidos</label>
              <input
                type="text"
                className="form-control"
                value={getValue(coach, "last_name")}
                onChange={(e) => setPropiedadCoach("last_name", e.target.value)}
              />
            </div>
          </div>

          <FileInput
            type="image"
            label="Fotografía"
            valueKey="picture"
            value={
              coach.picture && coach.picture !== null
                ? coach.picture
                : coach.file
            }
            modifier={setPropiedadCoach}
          />
          <label>Fecha de Nacimiento</label>
          <BirthdateInput
            value={getValue(coach, "birthdate")}
            modifier={(value) => setPropiedadCoach("birthdate", value)}
          />
          <label>Apodo</label>
          <input
            type="text"
            className="form-control mb-3"
            value={getValue(coach, "nick_name")}
            onChange={(e) => setPropiedadCoach("nick_name", e.target.value)}
          />

          <div className="row">
            <div className="col-6">
              <label>Instagram</label>
              <input
                type="text"
                className="form-control mb-3"
                value={getValue(coach, "instagram")}
                onChange={(e) => setPropiedadCoach("instagram", e.target.value)}
              />
            </div>

            <div className="col-6 ">
              <label>TikTok</label>
              <input
                type="text"
                className="form-control mb-3"
                value={getValue(coach, "tiktok")}
                onChange={(e) => setPropiedadCoach("tiktok", e.target.value)}
              />
            </div>
          </div>
          
          <label>Quote</label>
          <input
            type="text"
            className="form-control mb-3"
            value={getValue(coach, "quote")}
            onChange={(e) => setPropiedadCoach("quote", e.target.value)}
          />
          <label>Bio</label>
          <textarea
            rows="5"
            className="form-control mb-3"
            value={getValue(coach, "short_bio")}
            onChange={(e) => setPropiedadCoach("short_bio", e.target.value)}
          />
          {renderShowHome()}
          <SelectDiscountCoach coach={coach} modifier={handleCoachDiscount} />
          {!isNaN(idCoach) && (
            <SelectCoachCustomer coach={coach} modifier={setPropiedadCoach} />
          )}
          <div className="row mt-2">
            <div className="col-6">
              <button
                type="button"
                onClick={handleCancel}
                className="btn text-muted w-100"
              >
                Cancelar
              </button>
            </div>
            <div className="col-6">
              <button type="submit" className="btn btn-primary w-100">
                Guardar
              </button>
            </div>
          </div>
        </form>
      );
    }
  };

  return <div className="container-fluid px-0">{renderForm()}</div>;
};

export default CoachForm;
